export default __webpack_public_path__ + "static/media/SX.0bc24817.svg";